import { httpRequest } from 'http'
import {
    clan_supply_progression_settings_mock,
} from '../../containers/ClanLanding/mocks/clan_supply_progression_settings_mock'
import { requestVehicleInfo } from 'helpers/web_to_client'

export const CLAN_SUPPLY_PROGRESSION_SETTINGS_REQUEST = 'clan_supply_progression_settings/INFO_REQUEST'
export const CLAN_SUPPLY_PROGRESSION_SETTINGS_SUCCESS = 'clan_supply_progression_settings/INFO_SUCCESS'
export const CLAN_SUPPLY_PROGRESSION_SETTINGS_ERROR = 'clan_supply_progression_settings/INFO_ERROR'

export function clanSupplyProgressionSettingsRequestStart() {
    return {
        type: CLAN_SUPPLY_PROGRESSION_SETTINGS_REQUEST,
    }
}

export function clanSupplyProgressionSettingsRequestSuccess(data) {
    return {
        type: CLAN_SUPPLY_PROGRESSION_SETTINGS_SUCCESS,
        payload: data,
    }
}

export function clanSupplyProgressionSettingsRequestError(errorData) {
    return {
        type: CLAN_SUPPLY_PROGRESSION_SETTINGS_ERROR,
        payload: errorData,
    }
}

export const REQUEST_INTERVAL = 5000

export function requestClanSupplyProgressionSettingsInfo() {
    return async (dispatch, getState) => {
        const state = getState()
        const requestNotPossibleByTimeout = state.clanSupplyProgressionSettings.lastRequestTimestamp &&
            (Date.now() - state.clanSupplyProgressionSettings.lastRequestTimestamp) < REQUEST_INTERVAL
        if (state.clanSupplyProgressionSettings.loading || requestNotPossibleByTimeout) {
            return
        }

        dispatch(clanSupplyProgressionSettingsRequestStart())

        try {
            const request = process.env.API_ENV === 'mock' ?
                clan_supply_progression_settings_mock() :
                httpRequest(`${window.config.WGCG_API_URL}/clansupply/landing/campaign_map/settings/`)

            const data = await request

            if (data && data.prize && data.prize.cd) {
                const vehicleInfo = await requestVehicleInfo(data.prize.cd)

                if (vehicleInfo && vehicleInfo.vehicle.short_name) {
                    data.prize.title = vehicleInfo.vehicle.short_name
                }
            }

            dispatch(clanSupplyProgressionSettingsRequestSuccess(data))
        } catch (errorData) {
            if (errorData.statusCode === 503) {
                dispatch(clanSupplyProgressionSettingsRequestSuccess({ enabled: false }))

                return
            }
            dispatch(clanSupplyProgressionSettingsRequestError(errorData))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan_supply_progression_settings.js